













































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import AuditLimbahTajamService from "@/services/AuditLimbahTajamService";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { userModule } from "@/store/modules/user";
import { localISODate, parseLocalDate } from "@/utils/localDate";
import {
  ALT_ITEM_COUNT,
  AUDIT_LIMBAH_TAJAM_PRIVILEGE,
  KATEGORI_AUDIT_LIMBAH_TAJAM,
  KELOMPOK_AUDIT_LIMBAH_TAJAM,
  KRITERIA_AUDIT_LIMBAH_TAJAM,
  KategoriAuditLimbahTajam
} from "@/constants/kriteriaAuditLimbahTajam";

type SignStageKey = "auditor" | "karu";

const KATEGORI_TEKS: Record<KategoriAuditLimbahTajam, string> = {
  sangat_baik: "Sangat Baik (≥ 85%)",
  baik: "Baik (76–84%)",
  cukup_kurang: "Cukup/Kurang (< 76%)"
};

@Component({
  components: { VCDateTimePicker }
})
export default class AuditLimbahTajamDetail extends Vue {
  @Prop({ required: true }) readonly sessionId!: number;

  session: any = null;
  itemCount = ALT_ITEM_COUNT;

  signDialog = false;
  signStage: SignStageKey | null = null;
  signPassword = "";
  signing = false;

  temuanDialog = false;
  temuanForm: any = {};
  savingTemuan = false;

  deleteDialog = false;
  deleteTarget: any = null;
  deleting = false;

  kesimpulanModel = "";

  kategoriOptions = (Object.keys(KATEGORI_TEKS) as KategoriAuditLimbahTajam[]).map(value => ({
    value,
    text: KATEGORI_TEKS[value],
    color: KATEGORI_AUDIT_LIMBAH_TAJAM[value].color
  }));

  kriteriaSelectOptions = KRITERIA_AUDIT_LIMBAH_TAJAM.map(k => ({
    text: `${k.no_label}. ${k.kriteria}`,
    value: k.no
  }));

  statusTemuanOptions = [
    { text: "Open", value: "open" },
    { text: "In Progress", value: "in_progress" },
    { text: "Closed", value: "closed" },
    { text: "Overdue", value: "overdue" }
  ];

  temuanHeaders = [
    { text: "No", value: "urutan", width: 40 },
    { text: "Item", value: "kriteria_no", width: 60 },
    { text: "Analisis Temuan", value: "uraian" },
    { text: "Tindakan Perbaikan", value: "rencana_tindak_lanjut" },
    { text: "PIC", value: "pic_nama" },
    { text: "Batas Waktu", value: "target_waktu" },
    { text: "Status", value: "status_chip", sortable: false },
    { text: "", value: "actions", sortable: false, width: 80 }
  ];

  signStages = [
    {
      key: "auditor" as SignStageKey,
      label: "Auditor / Tim PPI",
      sub: "Dibuat Oleh",
      timestampField: "signed_auditor_at",
      getName: (s: any) => s.auditor_nama || (s.auditor && s.auditor.identitas && s.auditor.identitas.nama)
    },
    {
      key: "karu" as SignStageKey,
      label: "Ka. Ruang / Petugas Jaga",
      sub: "Mengetahui",
      timestampField: "signed_karu_at",
      getName: (s: any) => s.signed_karu && s.signed_karu.identitas && s.signed_karu.identitas.nama
    }
  ];

  get canCreate(): boolean {
    return userModule.hasPrivilege(AUDIT_LIMBAH_TAJAM_PRIVILEGE, "create");
  }

  get canUpdate(): boolean {
    return userModule.hasPrivilege(AUDIT_LIMBAH_TAJAM_PRIVILEGE, "update");
  }

  get currentUserId(): number | null {
    return userModule.user ? userModule.user.id : null;
  }

  get hasDenominator(): boolean {
    return this.session.total_patuh + this.session.total_tidak_patuh > 0;
  }

  get kesimpulanHint(): string {
    if (this.session.is_locked) return "Terkunci setelah TTD Auditor";
    if (!this.canUpdate) return "Anda tidak memiliki hak ubah audit ini";
    return "Tersimpan otomatis saat fokus keluar";
  }

  get temuanLockedReason(): string {
    if (this.session.is_temuan_locked) {
      return "Temuan & rencana tindak lanjut terkunci karena sudah ditandatangani Ka. Ruang / Petugas Jaga.";
    }
    if (!this.canCreate && !this.canUpdate) {
      return "Anda hanya memiliki hak lihat; temuan diisi oleh Tim PPI.";
    }
    return "";
  }

  get canAddTemuan(): boolean {
    return this.canCreate && !this.session.is_temuan_locked;
  }

  get canEditTemuan(): boolean {
    return this.canUpdate && !this.session.is_temuan_locked;
  }

  get canSaveTemuan(): boolean {
    return !!(this.temuanForm.uraian && this.temuanForm.rencana_tindak_lanjut);
  }

  get targetWaktuDate(): Date | null {
    return parseLocalDate(this.temuanForm.target_waktu);
  }

  set targetWaktuDate(val: Date | null) {
    this.$set(this.temuanForm, "target_waktu", val ? localISODate(val) : null);
  }

  get signStageLabel(): string {
    const s = this.signStages.find(x => x.key === this.signStage);
    return s ? `${s.label} — ${s.sub}` : "";
  }

  get responsesTable() {
    const map: Record<number, any> = {};
    (this.session?.responses || []).forEach((r: any) => (map[r.kriteria_no] = r));
    let lastGrup: string | null = null;
    return KRITERIA_AUDIT_LIMBAH_TAJAM.map(k => {
      const r = map[k.no] || {};
      const groupHeader = k.kelompok !== lastGrup ? KELOMPOK_AUDIT_LIMBAH_TAJAM[k.kelompok] : null;
      lastGrup = k.kelompok;
      return {
        no: k.no,
        no_label: k.no_label,
        kelompok: k.kelompok,
        groupHeader,
        kriteria: k.kriteria,
        penilaian: r.penilaian ?? null,
        catatan: r.catatan || ""
      };
    });
  }

  signBlockedReason(stage: SignStageKey): string {
    const s = this.session;
    if (stage === "auditor") {
      if (!this.canCreate) return "Hanya Tim PPI yang dapat menandatangani sebagai Auditor";
      if (s.auditor_id && s.auditor_id !== this.currentUserId) return "Hanya Auditor yang tercatat yang dapat menandatangani";
      if (s.total_patuh + s.total_tidak_patuh === 0) return "Minimal 1 item dinilai Ya/Tidak";
      return "";
    }
    if (!s.signed_auditor_at) return "Menunggu TTD Auditor";
    if (s.auditor_id === this.currentUserId) return "Harus ditandatangani orang selain Auditor";
    return "";
  }

  itemLabel(no: number | null): string {
    if (!no) return "—";
    const k = KRITERIA_AUDIT_LIMBAH_TAJAM.find(x => x.no === no);
    return k ? k.no_label : String(no);
  }

  async mounted() {
    await this.loadSession();
  }

  async loadSession() {
    const res = await AuditLimbahTajamService.find(this.sessionId);
    this.session = res.data.data;
    this.kesimpulanModel = this.session.kesimpulan_umum || "";
  }

  async saveKesimpulan() {
    if (this.session.is_locked || !this.canUpdate) return;
    if ((this.kesimpulanModel || "") === (this.session.kesimpulan_umum || "")) return;
    await AuditLimbahTajamService.update(this.session.id, {
      unit_id: this.session.unit_id,
      tanggal_audit: this.session.tanggal_audit,
      metode_audit: this.session.metode_audit,
      periode_bulan: this.session.periode_bulan,
      periode_tahun: this.session.periode_tahun,
      kesimpulan_umum: this.kesimpulanModel
    });
    this.session.kesimpulan_umum = this.kesimpulanModel;
  }

  formatHariTanggal(s: string): string {
    const d = parseLocalDate(s);
    if (!d) return "-";
    return d.toLocaleDateString("id-ID", { weekday: "long", day: "2-digit", month: "long", year: "numeric" });
  }

  formatTanggal(s: string | null): string {
    const d = parseLocalDate(s);
    return d ? d.toLocaleDateString("id-ID") : "—";
  }

  formatDateTime(s: string): string {
    if (!s) return "-";
    return new Date(s).toLocaleString("id-ID");
  }

  jam(s: string | null): string {
    return s ? String(s).slice(0, 5) : "—";
  }

  bulanName(b: number): string {
    const names = ["", "Januari", "Februari", "Maret", "April", "Mei", "Juni",
      "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
    return names[b] || "";
  }

  printPdf() {
    AuditLimbahTajamService.printPdf(this.session.id);
  }

  openSignDialog(stage: SignStageKey) {
    this.signStage = stage;
    this.signPassword = "";
    this.signDialog = true;
  }

  async confirmSign() {
    if (!this.signStage) return;
    this.signing = true;
    try {
      if (this.signStage === "auditor") {
        await AuditLimbahTajamService.submitAuditor(this.session.id, { password: this.signPassword });
      } else {
        await AuditLimbahTajamService.acknowledgeKaru(this.session.id, { password: this.signPassword });
      }
      this.signDialog = false;
      await this.loadSession();
      this.$emit("updated");
    } finally {
      this.signing = false;
    }
  }

  openTemuan(t?: any) {
    this.temuanForm = t
      ? {
          id: t.id,
          kriteria_no: t.kriteria_no,
          uraian: t.uraian || "",
          akar_masalah: t.akar_masalah || "",
          rencana_tindak_lanjut: t.rencana_tindak_lanjut || "",
          pic_nama: t.pic_nama || "",
          target_waktu: t.target_waktu || null,
          status: t.status || "open"
        }
      : {
          kriteria_no: null,
          uraian: "",
          akar_masalah: "",
          rencana_tindak_lanjut: "",
          pic_nama: "",
          target_waktu: null,
          status: "open"
        };
    this.temuanDialog = true;
  }

  async saveTemuan() {
    if (!this.canSaveTemuan) return;
    this.savingTemuan = true;
    try {
      const { id, ...payload } = this.temuanForm;
      if (id) {
        await AuditLimbahTajamService.updateTemuan(this.session.id, id, payload);
      } else {
        await AuditLimbahTajamService.storeTemuan(this.session.id, payload);
      }
      this.temuanDialog = false;
      await this.loadSession();
    } finally {
      this.savingTemuan = false;
    }
  }

  askDeleteTemuan(t: any) {
    this.deleteTarget = t;
    this.deleteDialog = true;
  }

  async confirmDeleteTemuan() {
    if (!this.deleteTarget) return;
    this.deleting = true;
    try {
      await AuditLimbahTajamService.destroyTemuan(this.session.id, this.deleteTarget.id);
      this.deleteDialog = false;
      this.deleteTarget = null;
      await this.loadSession();
    } finally {
      this.deleting = false;
    }
  }
}
